import { Alert } from '@tvg/fuse/alert';
import { IconChevronRight } from '@tvg/fuse/icon/all';
import { Link } from '@tvg/fuse/link';
import FocusTrap from 'focus-trap-react';
import React, { useRef } from 'react';
import styles from './ErrorAlert.module.css';

export default function ErrorAlert() {
  const alertRef = useRef<HTMLDivElement>(null);

  return (
    <FocusTrap focusTrapOptions={{ initialFocus: false }}>
      <div className={styles.errorAlert__overlay}>
        <Alert
          ref={alertRef}
          heading="Sorry, an error has occurred"
          showIcon
          size="responsive"
          variant="error"
          aria-live="assertive"
          role="alert"
          className={styles.errorAlert}
        >
          <Link
            href=""
            size="medium"
            icon={<IconChevronRight />}
            iconRight
            underline
            className={styles.errorAlert__link}
          >
            Please refresh the page
          </Link>
        </Alert>
      </div>
    </FocusTrap>
  );
}
